import { useModuleBEM } from "@b2bportal/core-themes";
import { useDeviceType } from "@b2bportal/core-utilities";
import styles from "./styles.module.scss";

const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

/**
 * On desktop viewports, renders the app inside a centered phone-width iframe
 * so that all device detection hooks naturally return mobile values.
 * On mobile viewports or when already inside an iframe, renders children directly.
 */
export const DesktopMobileFrame = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [block, cn] = useModuleBEM(styles, "DesktopMobileFrame");
  const { isMobile } = useDeviceType();
  const isDesktop = !isMobile && !isInIframe();

  if (!isDesktop) {
    return <>{children}</>;
  }

  return (
    <div className={block}>
      <iframe
        src={window.location.href}
        title="HSBC | Hopper"
        className={cn("iframe")}
      />
    </div>
  );
};
